import _ from 'lodash';
import { gql } from '@apollo/client';
import { GET_APPROVALS, LIMIT as APPROVALS_LIMIT } from '../graphql';

export const LIMIT = 1000;

export const GET_TEST_SESSIONS = gql`
  query TestSessions(
    $projectId: ID!,
    $limit: Int,
    $removed: Boolean!,
  ) {
    testSessions(
      projectId: $projectId,
      limit: $limit,
      removed: $removed,
    ) {
      id
      moderatedVideoUrl
      status
      removed
      startAt
      meetingUrl
      meetingUrlTester
      bookingStatus
      expired
      tester {
        id
        screenerSession {
          id
        }
        segment {
          id
          name
          createdAt
        }
        user {
          tester
          id
          email
          profile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const INSERT_MODERATED_VIDEO = gql`
  mutation InsertModeratedVideo($testSessionId: ID!, $videoUrl: String!) {
    insertModeratedVideo(testSessionId: $testSessionId, videoUrl: $videoUrl) {
      testSession {
        id
        moderatedVideoUrl
      }
    }
  }
`;

export const REMOVE_TEST_SESSION = gql`
  mutation RemoveTestSession($id: ID!, $removed: Boolean!) {
    removeTestSession(id: $id, removed: $removed) {
      testSession {
        id
        moderatedVideoUrl
        status
        removed
        tester {
          id
          user {
            id
            profile {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_TEST_SESSION_BOOKING_STATUS = gql`
  mutation UpdateTestSessionBookingStatus($id: ID!, $bookingStatus: TestSessionBookingStatusEnum!) {
    updateBookingStatus(id: $id, bookingStatus: $bookingStatus) {
      testSession {
        id
      }
    }
  }
`;

export const handleInsertModeratedVideoMutationUpdate = (projectId) => (cache, { data: { insertModeratedVideo } }) => {
  const cacheData = cache.readQuery({
    query: GET_TEST_SESSIONS,
    variables: {
      projectId,
      limit: 1000,
    },
  });

  if (!cacheData?.testSessions) return;

  const { testSessions: cachedTestSessions } = cacheData;

  const { testSession } = insertModeratedVideo;

  cache.writeQuery({
    query: GET_TEST_SESSIONS,
    variables: {
      projectId,
      limit: 1000,
    },
    data: {
      testSessions: _.map(
        cachedTestSessions,
        (cachedTestSession) => {
          if (cachedTestSession.id === testSession.id) {
            return {
              ...cachedTestSession,
              moderatedVideoUrl: testSession.moderatedVideoUrl,
            };
          }

          return cachedTestSession;
        },
      ),
    },
  });
};

export const handleMarkProjectAsDoneMutationUpdate = (cache, { data: { markProjectAsDone } }, source) => {
  const { approvals: cachedApprovals } = cache.readQuery({
    query: GET_APPROVALS,
    variables: {
      limit: APPROVALS_LIMIT,
      offset: 0,
      participantSource: [source],
    },
  });

  const { projectId } = markProjectAsDone;

  cache.writeQuery({
    query: GET_APPROVALS,
    data: {
      approvals: _.filter(
        cachedApprovals,
        (cachedApproval) => cachedApproval.project.id !== projectId,
      ),
    },
  });
};

export const updateTestSession = (projectId) => (cache) => {
  const variables = {
    projectId,
    limit: LIMIT,
    removed: false,
  };

  const { testSessions: cachedSessions } = cache.readQuery({
    query: GET_TEST_SESSIONS,
    variables,
  });

  const testSessions = _.filter(cachedSessions, (session) => !session.removed);

  cache.writeQuery({
    query: GET_TEST_SESSIONS,
    variables,
    data: {
      testSessions,
    },
  });
};
